

// import React, { useEffect, useState } from "react";
// import {
//   Card,
//   Button,
//   Drawer,
//   Form,
//   Input,
//   InputNumber,
//   Select,
//   Row,
//   Col,
//   message,
//   Typography,
//   Spin,
//   Badge,
//   Space,
//   Avatar,
//   Divider,
//   Tag,
//   Empty,
//   Tooltip,
//   DatePicker,
//   TimePicker,
// } from "antd";
// import {
//   ShoppingCartOutlined,
//   CloseOutlined,
//   PlusOutlined,
//   MinusOutlined,
//   UserOutlined,
//   PhoneOutlined,
//   MailOutlined,
//   TeamOutlined,
//   CalendarOutlined,
//   DollarOutlined,
//   CheckCircleOutlined,
//   SearchOutlined,
//   ClockCircleOutlined,
//   CreditCardOutlined
// } from "@ant-design/icons";
// import { createOrderApi } from "../../services/orderApi";
// import moment from "moment";
// import { useParams } from "react-router-dom";
// import { getServiceApi } from "../../services/serviceApi";
// import { getAllUsersApi } from "../../services/users";
// import { toast } from "react-toastify";

// const { Meta } = Card;
// const { Option } = Select;
// const { Title, Text } = Typography;
// const { Search } = Input;





// export default function CreateOrder() {
//   const [services, setServices] = useState([]);
//   const [filteredServices, setFilteredServices] = useState([]);
//   const [selectedServices, setSelectedServices] = useState([]);
//   const [drawerVisible, setDrawerVisible] = useState(false);
//   const [form] = Form.useForm();
//   const [staffList, setStaffList] = useState([]);
//   const [fetchingStaff, setFetchingStaff] = useState(false);
//   const [loading, setLoading] = useState(false);
//   const [submitting, setSubmitting] = useState(false);
//   const [searchValue, setSearchValue] = useState("");
//   const [orderType, setOrderType] = useState("");

//   // Mock company ID - replace with actual useParams
//   // const companyId = "company123";
//    let {companyId} = useParams()

//   useEffect(() => {
//     fetchServices();
//     fetchStaff();
//   }, []);

//   const fetchServices = async () => {
//     try {
//       setLoading(true);
//       const res = await getServiceApi({companyId:companyId});
//       setServices(res || []);
//       setFilteredServices(res || []);
//     } catch (err) {
//       message.error("Failed to fetch services");
//     } finally {
//       setLoading(false);
//     }
//   };

//   const fetchStaff = async (search = "") => {
//     try {
//       setFetchingStaff(true);
//       const res = await getAllUsersApi({ name: search, companyId });
//       setStaffList(res || []);
//     } catch (err) {
//       console.error("Error fetching staff", err);
//     } finally {
//       setFetchingStaff(false);
//     }
//   };

//   const handleSearch = (value) => {
//     setSearchValue(value);
//     const keyword = value.trim().toLowerCase();
    
//     if (!keyword) {
//       setFilteredServices(services);
//       return;
//     }

//     const filtered = services.filter((service) =>
//       service.name.toLowerCase().includes(keyword)
//     );
//     setFilteredServices(filtered);
//   };

//   const handleAddService = (service) => {
//     if (!selectedServices.some((s) => s._id === service._id)) {
//       setSelectedServices((prev) => [...prev, service]);
//       message.success(`${service.name} added to order`);
//     }
//   };

//   const handleRemoveService = (serviceId) => {
//     setSelectedServices((prev) => prev.filter((item) => item._id !== serviceId));
//   };

//   const handleTotalAmount = () => {
//     return selectedServices.reduce((sum, service) => sum + service.price, 0);
//   };

//   const handlePlaceOrder = () => {
//     if (selectedServices.length === 0) {
//       return message.warning("Please select at least one service.");
//     }
//     setDrawerVisible(true);
//   };
 

//   const handleSubmit = async (values) => {
//     try {

//       console.log(values,"values list")
//       // return 
//       const formattedDate = moment(values?.appointmentDate).format("DD/MM/YYYY");
//     const formattedTime = moment(values?.appointmentTime).format("HH:mm");
//            // Fix: DOB is already a moment object, so format it directly
//     const formattedDOB = values?.dob ? values.dob.format("YYYY-MM-DD") : null;

//       setSubmitting(true);
//       const payload = {
//         ...values,
//         totalAmount: handleTotalAmount(),
//          dob: formattedDOB,
//         appointmentDate:values?.appointmentDate,
//         appointmentTime:values?.appointmentTime,
//         appoinmentDate:formattedDate,
//         appoinmentTime:formattedTime,
//         type:'onsite',
//         serviceList: selectedServices.map((s) => ({
//           id: s._id,
//           name: s.name,
//           price: s.price,
//         })),
//       };
    
//       const res = await createOrderApi(companyId,payload);
      
//       if (!res?.success) {
//         toast.error(res?.message || 'Try again later!');
//         return;
//       }
      
//       toast.success('Order created successfully!');
//       setDrawerVisible(false);
//       setSelectedServices([]);
//       setOrderType("");
//       form.resetFields();
      
//     } catch (err) {
//       console.error(err);
//       message.error("Failed to place order");
//     } finally {
//       setSubmitting(false);
//     }
//   };

//   const getServiceImage = (service) => {
//     return service.image?.fileUrl || service.images?.[0] || null;
//   };

//   const ServiceCard = ({ service }) => {
//     const isSelected = selectedServices.some((s) => s._id === service._id);
//     const imageUrl = getServiceImage(service);

//     return (
//       <Card
//         hoverable
//         style={{
//           borderRadius: '16px',
//           overflow: 'hidden',
//           border: isSelected ? '2px solid #1890ff' : '1px solid #f0f0f0',
//           boxShadow: isSelected 
//             ? '0 8px 32px rgba(24,144,255,0.3)' 
//             : '0 4px 12px rgba(0,0,0,0.1)',
//           transition: 'all 0.3s ease',
//           position: 'relative',
//         }}
//         bodyStyle={{ padding: '16px' }}
//         cover={
//           <div style={{ 
//             position: 'relative', 
//             height: '180px',
//             background: imageUrl 
//               ? 'transparent' 
//               : 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
//             overflow: 'hidden'
//           }}>
//             {imageUrl ? (
//               <img
//                 src={imageUrl}
//                 alt={service.name}
//                 style={{
//                   width: '100%',
//                   height: '100%',
//                   objectFit: 'cover',
//                 }}
//               />
//             ) : (
//               <div style={{
//                 display: 'flex',
//                 flexDirection: 'column',
//                 alignItems: 'center',
//                 justifyContent: 'center',
//                 height: '100%',
//                 color: 'white',
//                 textAlign: 'center'
//               }}>
//                 <div style={{
//                   width: '60px',
//                   height: '60px',
//                   borderRadius: '50%',
//                   background: 'rgba(255,255,255,0.2)',
//                   display: 'flex',
//                   alignItems: 'center',
//                   justifyContent: 'center',
//                   marginBottom: '12px'
//                 }}>
//                   <span style={{ fontSize: '24px', fontWeight: 'bold' }}>
//                     {service.name.charAt(0).toUpperCase()}
//                   </span>
//                 </div>
//                 <Text style={{ color: 'white', fontSize: '12px', opacity: 0.8 }}>
//                   Service Image
//                 </Text>
//               </div>
//             )}

//             {/* Price Badge */}
//             <div style={{
//               position: 'absolute',
//               top: '12px',
//               right: '12px',
//               background: 'rgba(0,0,0,0.8)',
//               color: 'white',
//               padding: '6px 12px',
//               borderRadius: '16px',
//               fontSize: '14px',
//               fontWeight: 'bold',
//               backdropFilter: 'blur(4px)'
//             }}>
//               ₹{service.price}
//             </div>

//             {/* Selected Badge */}
//             {isSelected && (
//               <div style={{
//                 position: 'absolute',
//                 top: '12px',
//                 left: '12px',
//                 background: '#52c41a',
//                 color: 'white',
//                 padding: '4px 8px',
//                 borderRadius: '12px',
//                 fontSize: '12px',
//                 fontWeight: 'bold'
//               }}>
//                 <CheckCircleOutlined style={{ marginRight: '4px' }} />
//                 Added
//               </div>
//             )}
//           </div>
//         }
//         actions={[
//           isSelected ? (
//             <Button
//               danger
//               icon={<MinusOutlined />}
//               onClick={() => handleRemoveService(service._id)}
//               style={{ borderRadius: '8px' }}
//             >
//               Remove
//             </Button>
//           ) : (
//             <Button 
//               type="primary" 
//               icon={<PlusOutlined />}
//               onClick={() => handleAddService(service)}
//               style={{ borderRadius: '8px' }}
//             >
//               Add Service
//             </Button>
//           ),
//         ]}
//       >
//         <Meta 
//           title={
//             <Text strong style={{ fontSize: '16px', color: '#1a1a1a' }}>
//               {service.name}
//             </Text>
//           }
//           description={
//             <div style={{ marginTop: '8px' }}>
//               <Text type="secondary" style={{ fontSize: '14px' }}>
//                 Professional service
//               </Text>
//             </div>
//           }
//         />
//       </Card>
//     );
//   };

//   return (
//     <div style={{ 
//       minHeight: '100vh',
//       background: 'linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%)',
//       padding: '24px',
//       paddingBottom: selectedServices.length > 0 ? '120px' : '24px'
//     }}>
//       <div style={{ maxWidth: '1400px', margin: '0 auto' }}>
//         {/* Header */}
//         <div style={{
//           background: 'white',
//           borderRadius: '20px',
//           padding: '32px',
//           marginBottom: '24px',
//           boxShadow: '0 8px 32px rgba(0,0,0,0.1)'
//         }}>
//           <Row align="middle" justify="space-between">
//             <Col>
//               <Title level={2} style={{ 
//                 margin: 0,
//                 marginBottom: '8px',
//                 background: 'linear-gradient(45deg, #1890ff, #722ed1)',
//                 WebkitBackgroundClip: 'text',
//                 WebkitTextFillColor: 'transparent',
//                 fontSize: '32px'
//               }}>
//                 Create New Order
//               </Title>
//               <Text type="secondary" style={{ fontSize: '16px' }}>
//                 Select services and create an order for your client
//               </Text>
//             </Col>
//             <Col>
//               <Badge count={selectedServices.length} style={{ backgroundColor: '#52c41a' }}>
//                 <Avatar 
//                   size={48} 
//                   icon={<ShoppingCartOutlined />} 
//                   style={{ backgroundColor: '#1890ff' }}
//                 />
//               </Badge>
//             </Col>
//           </Row>
//         </div>

//         {/* Search */}
//         <div style={{
//           background: 'white',
//           borderRadius: '20px',
//           padding: '24px',
//           marginBottom: '24px',
//           boxShadow: '0 8px 32px rgba(0,0,0,0.1)'
//         }}>
//           <Row align="middle" gutter={[16, 16]}>
//             <Col xs={24} md={16}>
//               <Search
//                 placeholder="Search services..."
//                 size="large"
//                 prefix={<SearchOutlined />}
//                 value={searchValue}
//                 onChange={(e) => handleSearch(e.target.value)}
//                 style={{ borderRadius: '12px' }}
//                 allowClear
//               />
//             </Col>
//             <Col xs={24} md={8} style={{ textAlign: 'right' }}>
//               <div style={{
//                 background: 'linear-gradient(45deg, #1890ff, #722ed1)',
//                 color: 'white',
//                 padding: '8px 16px',
//                 borderRadius: '20px',
//                 fontSize: '14px',
//                 fontWeight: 'bold',
//                 display: 'inline-block'
//               }}>
//                 {filteredServices.length} Services Available
//               </div>
//             </Col>
//           </Row>
//         </div>

//         {/* Services Grid */}
//         <div style={{
//           background: 'white',
//           borderRadius: '20px',
//           padding: '24px',
//           boxShadow: '0 8px 32px rgba(0,0,0,0.1)'
//         }}>
//           {loading ? (
//             <div style={{ textAlign: 'center', padding: '60px 0' }}>
//               <Spin size="large" />
//               <div style={{ marginTop: '16px' }}>
//                 <Text type="secondary">Loading services...</Text>
//               </div>
//             </div>
//           ) : filteredServices.length === 0 ? (
//             <div style={{ textAlign: 'center', padding: '60px 0' }}>
//               <Empty 
//                 description={
//                   searchValue 
//                     ? `No services found for "${searchValue}"` 
//                     : "No services available"
//                 }
//                 image={Empty.PRESENTED_IMAGE_SIMPLE}
//               />
//             </div>
//           ) : (
//             <Row gutter={[24, 24]}>
//               {filteredServices.map((service) => (
//                 <Col xs={24} sm={12} md={8} lg={6} key={service._id}>
//                   <ServiceCard service={service} />
//                 </Col>
//               ))}
//             </Row>
//           )}
//         </div>
//       </div>

//       {/* Selected Services Footer */}
//       {selectedServices.length > 0 && (
//         <div style={{
//           position: "fixed",
//           bottom: 0,
//           left: 0,
//           right: 0,
//           background: "white",
//           padding: "20px 24px",
//           boxShadow: "0 -4px 20px rgba(0, 0, 0, 0.1)",
//           borderTop: "1px solid #f0f0f0",
//           zIndex: 1000,
//         }}>
//           <div style={{ maxWidth: '1400px', margin: '0 auto' }}>
//             <div style={{
//               display: "flex",
//               overflowX: "auto",
//               gap: "12px",
//               marginBottom: "16px",
//               paddingBottom: "8px",
//             }}>
//               {selectedServices.map((service) => (
//                 <div
//                   key={service._id}
//                   style={{
//                     background: "linear-gradient(135deg, #f0f9ff 0%, #e0e7ff 100%)",
//                     border: "1px solid #bfdbfe",
//                     padding: "12px 16px",
//                     borderRadius: "12px",
//                     minWidth: "180px",
//                     position: "relative",
//                     whiteSpace: "nowrap",
//                   }}
//                 >
//                   <div style={{ fontWeight: 600, fontSize: "14px", color: "#1e40af" }}>
//                     {service.name}
//                   </div>
//                   <div style={{ fontSize: "12px", color: "#64748b", marginTop: "4px" }}>
//                     ₹{service.price}
//                   </div>
//                   <Button
//                     type="text"
//                     size="small"
//                     icon={<CloseOutlined />}
//                     onClick={() => handleRemoveService(service._id)}
//                     style={{
//                       position: "absolute",
//                       top: "4px",
//                       right: "4px",
//                       width: "20px",
//                       height: "20px",
//                       display: "flex",
//                       alignItems: "center",
//                       justifyContent: "center",
//                       color: "#64748b",
//                       border: 'none',
//                       background: 'rgba(255, 255, 255, 0.9)',
//                       borderRadius: '50%',
//                       fontSize: '10px',
//                       boxShadow: '0 1px 4px rgba(0,0,0,0.1)'
//                     }}
//                   />
//                 </div>
//               ))}
//             </div>

//             <Row align="middle" justify="space-between">
//               <Col>
//                 <Space align="center">
//                   <DollarOutlined style={{ color: '#52c41a', fontSize: '18px' }} />
//                   <Text strong style={{ fontSize: '18px', color: '#52c41a' }}>
//                     Total: ₹{handleTotalAmount()}
//                   </Text>
//                   <Text type="secondary">
//                     ({selectedServices.length} service{selectedServices.length !== 1 ? 's' : ''})
//                   </Text>
//                 </Space>
//               </Col>
//               <Col>
//                 <Button
//                   type="primary"
//                   size="large"
//                   icon={<ShoppingCartOutlined />}
//                   onClick={handlePlaceOrder}
//                   style={{
//                     borderRadius: '12px',
//                     background: 'linear-gradient(45deg, #1890ff, #722ed1)',
//                     border: 'none',
//                     boxShadow: '0 4px 12px rgba(24,144,255,0.4)',
//                     minWidth: '140px'
//                   }}
//                 >
//                   Place Order
//                 </Button>
//               </Col>
//             </Row>
//           </div>
//         </div>
//       )}

//       {/* Order Drawer */}
//       <Drawer
//         title={
//           <div style={{ fontSize: '20px', fontWeight: 'bold' }}>
//             <ShoppingCartOutlined style={{ marginRight: '8px', color: '#1890ff' }} />
//             Place Order
//           </div>
//         }
//         width={500}
//         onClose={() => {
//           setDrawerVisible(false);
//           setOrderType("");
//         }}
//         open={drawerVisible}
//         destroyOnClose
//         style={{ borderRadius: '16px' }}
//       >
//         <div style={{ marginBottom: '24px' }}>
//           <Title level={4} style={{ color: '#1890ff', marginBottom: '16px' }}>
//             Order Summary
//           </Title>
//           <div style={{
//             background: '#f8fafc',
//             padding: '16px',
//             borderRadius: '12px',
//             marginBottom: '24px'
//           }}>
//             {selectedServices.map((service, index) => (
//               <div key={service._id}>
//                 <Row justify="space-between" align="middle">
//                   <Col>
//                     <Text strong>{service.name}</Text>
//                   </Col>
//                   <Col>
//                     <Text strong style={{ color: '#52c41a' }}>₹{service.price}</Text>
//                   </Col>
//                 </Row>
//                 {index < selectedServices.length - 1 && <Divider style={{ margin: '8px 0' }} />}
//               </div>
//             ))}
//             <Divider />
//             <Row justify="space-between" align="middle">
//               <Col>
//                 <Text strong style={{ fontSize: '16px' }}>Total Amount</Text>
//               </Col>
//               <Col>
//                 <Text strong style={{ fontSize: '18px', color: '#1890ff' }}>
//                   ₹{handleTotalAmount()}
//                 </Text>
//               </Col>
//             </Row>
//           </div>
//         </div>

//         <Form layout="vertical" form={form} onFinish={handleSubmit}>
//           <Title level={4} style={{ color: '#1890ff', marginBottom: '16px' }}>
//             Client Information
//           </Title>

//           <Form.Item
//             name="clientName"
//             label={<Text strong><UserOutlined style={{ marginRight: '4px' }} />Client Name</Text>}
//             rules={[{ required: true, message: "Enter client name" }]}
//           >
//             <Input 
//               placeholder="Enter client full name"
//               size="large"
//               style={{ borderRadius: '8px' }}
//             />
//           </Form.Item>

//           <Form.Item
//             name="number"
//             label={<Text strong><PhoneOutlined style={{ marginRight: '4px' }} />Mobile Number</Text>}
//             rules={[
//               { required: true, message: "Enter mobile number" },
//               { len: 10, message: "Must be 10 digits" },
//             ]}
//           >
//             <Input 
//               placeholder="Enter 10-digit mobile number"
//               size="large"
//               style={{ borderRadius: '8px' }}
//             />
//           </Form.Item>
// <Form.Item
//   name="dob"
//   label={
//     <Text strong>
//       <CalendarOutlined style={{ marginRight: '4px' }} />
//       Date of Birth
//     </Text>
//   }
//   rules={[
//     { required: true, message: 'Please select your date of birth' },
//     {
//       validator: (_, value) => {
//         if (!value) return Promise.resolve();
        
//         const today = moment();
//         const birthDate = moment(value);
//         const age = today.diff(birthDate, 'years');
        
//         // if (age < 13) {
//         //   return Promise.reject(new Error('Must be at least 13 years old'));
//         // }
//         // if (age > 120) {
//         //   return Promise.reject(new Error('Please enter a valid date of birth'));
//         // }
        
//         return Promise.resolve();
//       }
//     }
//   ]}
// >
//   <DatePicker
//     placeholder="Select date of birth"
//     size="large"
//     style={{ width: '100%', borderRadius: '8px' }}
//     format="DD/MM/YYYY"
//     disabledDate={(current) => {
//       // Disable future dates and dates more than 120 years ago
//       const today = moment().endOf('day');
//       const minDate = moment().subtract(120, 'years');
//       return current && (current > today || current < minDate);
//     }}
//     showToday={false}
//     picker="date"
//   />
// </Form.Item>
//           <Form.Item 
//             name="email" 
//             label={<Text strong><MailOutlined style={{ marginRight: '4px' }} />Email (Optional)</Text>}
//           >
//             <Input 
//               type="email" 
//               placeholder="Enter email address"
//               size="large"
//               style={{ borderRadius: '8px' }}
//             />
//           </Form.Item>

//           <Divider />

//           <Title level={4} style={{ color: '#1890ff', marginBottom: '16px' }}>
//             Service Details
//           </Title>

//           <Form.Item
//             name={["staff", "userId"]}
//             label={<Text strong><TeamOutlined style={{ marginRight: '4px' }} />Select Staff</Text>}
//             rules={[{ required: true, message: "Please select staff" }]}
//           >
//             <Select
//               showSearch
//               placeholder="Search and select staff member"
//               size="large"
//               filterOption={false}
//               onSearch={fetchStaff}
//               loading={fetchingStaff}
//               notFoundContent={fetchingStaff ? <Spin size="small" /> : "No staff found"}
//               onChange={(value, option) => {
//                 // Extract staff name from option label
//                 const staffName = staffList.find(staff => staff._id === value)?.name || '';
//                 form.setFieldValue(["staff", "userName"], staffName);
//               }}
//               style={{ borderRadius: '8px' }}
//               dropdownStyle={{ borderRadius: '8px' }}
//             >
//               {staffList.map((user) => (
//                 <Option key={user._id} value={user._id}>
//                   <Space align="center">
//                     <Avatar 
//                       size="small" 
//                       icon={<UserOutlined />} 
//                       style={{ 
//                         backgroundColor: '#1890ff',
//                         flexShrink: 0
//                       }} 
//                     />
//                     <div style={{ overflow: 'hidden' }}>
//                       <div style={{ 
//                         fontWeight: '500',
//                         color: '#262626',
//                         whiteSpace: 'nowrap',
//                         overflow: 'hidden',
//                         textOverflow: 'ellipsis'
//                       }}>
//                         {user.name}
//                       </div>
//                       {/* <Text 
//                         type="secondary" 
//                         style={{ 
//                           fontSize: '12px',
//                           whiteSpace: 'nowrap',
//                           overflow: 'hidden',
//                           textOverflow: 'ellipsis',
//                           display: 'block'
//                         }}
//                       >
//                         {user.email}
//                       </Text> */}
//                     </div>
//                   </Space>
//                 </Option>
//               ))}
//             </Select>
//           </Form.Item>

//           <Form.Item
//             name={["staff", "userName"]}
//             style={{ display: 'none' }}
//           >
//             <Input />
//           </Form.Item>

//           {/* <Form.Item
//             name="type"
//             label={<Text strong><CalendarOutlined style={{ marginRight: '4px' }} />Order Type</Text>}
//             rules={[{ required: true, message: "Select order type" }]}
//           >
//             <Select 
//               placeholder="Select service type"
//               size="large"
//               style={{ borderRadius: '8px' }}
//               onChange={(value) => setOrderType(value)}
//             >
//               <Option value="onsite">
//                 <Space>
//                   <Tag color="blue">Onsite</Tag>
//                   <span>Service at salon</span>
//                 </Space>
//               </Option>
//               <Option value="scheduled">
//                 <Space>
//                   <Tag color="orange">Scheduled</Tag>
//                   <span>Appointment booking</span>
//                 </Space>
//               </Option>
//             </Select>
//           </Form.Item> */}

//           {/* Appointment Date & Time Fields - Only show for scheduled orders */}
//           {orderType === "scheduled" && (
//             <>
//               <Form.Item
//                 name="appointmentDate"
//                 label={<Text strong><CalendarOutlined style={{ marginRight: '4px' }} />Appointment Date</Text>}
//                 rules={[{ required: true, message: "Please select appointment date" }]}
//               >
//                 <DatePicker
//                   size="large"
//                   style={{ width: '100%', borderRadius: '8px' }}
//                   placeholder="Select appointment date"
//                   disabledDate={(current) => current && current.isBefore(new Date(), 'day')}
//                   format="DD/MM/YYYY"
//                 />
//               </Form.Item>

//               <Form.Item
//                 name="appointmentTime"
//                 label={<Text strong><ClockCircleOutlined style={{ marginRight: '4px' }} />Appointment Time</Text>}
//                 rules={[{ required: true, message: "Please select appointment time" }]}
//               >
//                 <TimePicker
//                   size="large"
//                   style={{ width: '100%', borderRadius: '8px' }}
//                   placeholder="Select appointment time"
//                   format="HH:mm"
//                   minuteStep={15}
//                   showNow={false}
//                 />
//               </Form.Item>

//               <div style={{
//                 background: '#e6f7ff',
//                 border: '1px solid #91d5ff',
//                 borderRadius: '8px',
//                 padding: '12px',
//                 marginBottom: '16px'
//               }}>
//                 <Space>
//                   <ClockCircleOutlined style={{ color: '#1890ff' }} />
//                   <Text style={{ fontSize: '12px', color: '#1890ff' }}>
//                     <strong>Note:</strong> Appointment will be scheduled for the selected date and time. 
//                     Please ensure the selected slot is available.
//                   </Text>
//                 </Space>
//               </div>
//             </>
//           )}
//           <Form.Item
//               name="paymentMode"
//               label={<Text strong><CreditCardOutlined style={{ marginRight: '4px' }} />Payment Mode</Text>}
//               rules={[{ required: true, message: "Please select payment mode" }]}
//             >
//               <Select 
//                 placeholder="Select payment method"
//                 size="large"
//                 style={{ borderRadius: '8px' }}
//               >
//                 <Option value="cash">
//                   <Space>
//                     <DollarOutlined style={{ color: '#52c41a' }} />
//                     <span>Cash Payment</span>
//                   </Space>
//                 </Option>
//                 <Option value="online">
//                   <Space>
//                     <CreditCardOutlined style={{ color: '#1890ff' }} />
//                     <span>Online Payment</span>
//                   </Space>
//                 </Option>
//               </Select>
//             </Form.Item>

//           <Form.Item style={{ marginTop: '32px' }}>
//             <Button
//               type="primary"
//               htmlType="submit"
//               size="large"
//               loading={submitting}
//               block
//               style={{
//                 borderRadius: '12px',
//                 height: '48px',
//                 background: 'linear-gradient(45deg, #52c41a, #389e0d)',
//                 border: 'none',
//                 fontSize: '16px',
//                 fontWeight: 'bold'
//               }}
//             >
//               {submitting ? 'Creating Order...' : 'Confirm & Place Order'}
//             </Button>
//           </Form.Item>
//         </Form>
//       </Drawer>
//     </div>
//   );
// }


import React, { useEffect, useState } from "react";
import {
  Card,
  Button,
  Drawer,
  Form,
  Input,
  InputNumber,
  Select,
  Row,
  Col,
  message,
  Typography,
  Spin,
  Badge,
  Space,
  Avatar,
  Divider,
  Tag,
  Empty,
  Tooltip,
  DatePicker,
  TimePicker,
  AutoComplete,
  Progress,
} from "antd";
import {
  ShoppingCartOutlined,
  CloseOutlined,
  PlusOutlined,
  MinusOutlined,
  UserOutlined,
  PhoneOutlined,
  MailOutlined,
  TeamOutlined,
  CalendarOutlined,
  DollarOutlined,
  CheckCircleOutlined,
  SearchOutlined,
  ClockCircleOutlined,
  CreditCardOutlined,
  GiftOutlined,
  PercentageOutlined,
  TagOutlined,
  CrownOutlined,
} from "@ant-design/icons";
import { createOrderApi } from "../../services/orderApi";
import moment from "moment";
import { useParams } from "react-router-dom";
import { getServiceApi } from "../../services/serviceApi";
import { getAllUsersApi } from "../../services/users";
import { getMembers } from "../../services/memberService";
import { toast } from "react-toastify";
import { validateDiscountCode } from "../../services/discountApi";

const { Meta } = Card;
const { Option } = Select;
const { Title, Text } = Typography;
const { Search } = Input;

// Add this API function for discount verification
// const verifyDiscountCodeApi = async ( code, orderAmount) => {
//   try {
//     const response = await validateDiscountCode({companyId})
//   } catch (error) {
//     console.error('Error verifying discount code:', error);
//     throw error;
//   }
// };

export default function CreateOrder() {
  const [services, setServices] = useState([]);
  const [filteredServices, setFilteredServices] = useState([]);
  const [selectedServices, setSelectedServices] = useState([]);
  const [drawerVisible, setDrawerVisible] = useState(false);
  const [form] = Form.useForm();
  const [staffList, setStaffList] = useState([]);
  const [fetchingStaff, setFetchingStaff] = useState(false);
  const [loading, setLoading] = useState(false);
  const [submitting, setSubmitting] = useState(false);
  const [searchValue, setSearchValue] = useState("");
  const [orderType, setOrderType] = useState("");
  
  // Discount code states
  const [discountCode, setDiscountCode] = useState("");
  const [appliedDiscount, setAppliedDiscount] = useState(null);
  const [verifyingDiscount, setVerifyingDiscount] = useState(false);
  const [discountError, setDiscountError] = useState("");

  // Member search states
  const [memberPhoneSearch, setMemberPhoneSearch] = useState("");
  const [memberOptions, setMemberOptions] = useState([]);
  const [memberSearchLoading, setMemberSearchLoading] = useState(false);
  const [selectedMember, setSelectedMember] = useState(null);

  let {companyId} = useParams()

  useEffect(() => {
    fetchServices();
    fetchStaff();
  }, []);

  const fetchServices = async () => {
    try {
      setLoading(true);
      const res = await getServiceApi({companyId:companyId});
      setServices(res || []);
      setFilteredServices(res || []);
    } catch (err) {
      message.error("Failed to fetch services");
    } finally {
      setLoading(false);
    }
  };

  const fetchStaff = async (search = "") => {
    try {
      setFetchingStaff(true);
      const res = await getAllUsersApi({ name: search, companyId });
      setStaffList(res || []);
    } catch (err) {
      console.error("Error fetching staff", err);
    } finally {
      setFetchingStaff(false);
    }
  };

  const searchMembersByPhone = async (phone) => {
    setMemberPhoneSearch(phone);
    if (!phone || phone.length < 3) { setMemberOptions([]); return; }
    setMemberSearchLoading(true);
    try {
      const res = await getMembers({ companyId, search: phone });
      const list = res?.data || [];
      setMemberOptions(list.map(m => ({
        value: m.phone,
        label: (
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <Space>
              <Avatar size="small" icon={<UserOutlined />} style={{ backgroundColor: '#1890ff' }} />
              <div>
                <div style={{ fontWeight: 600, fontSize: 13 }}>{m.name}</div>
                <div style={{ fontSize: 11, color: '#888' }}>{m.phone} {m.email ? `· ${m.email}` : ''}</div>
              </div>
            </Space>
            {m.membershipPlan?.isActive && (
              <Tag color="gold" icon={<CrownOutlined />} style={{ fontSize: 10 }}>Member</Tag>
            )}
          </div>
        ),
        member: m,
      })));
    } catch (err) {
      console.error('Member search error:', err);
    } finally {
      setMemberSearchLoading(false);
    }
  };

  const handleMemberSelect = (value, option) => {
    const m = option.member;
    setSelectedMember(m);
    setMemberPhoneSearch(m.phone);
    form.setFieldsValue({
      clientName: m.name,
      number: m.phone,
      email: m.email || '',
      dob: m.dob ? moment(m.dob) : undefined,
    });
    // Reset discount since pricing may change
    setAppliedDiscount(null);
    setDiscountCode('');
    setDiscountError('');
  };

  const clearMember = () => {
    setSelectedMember(null);
    setMemberPhoneSearch('');
    setMemberOptions([]);
    form.setFieldsValue({ clientName: '', number: '', email: '', dob: undefined });
  };

  // Returns remaining count for this service in member plan, or null if not in plan
  const getMembershipCoverage = (serviceId) => {
    if (!selectedMember?.membershipPlan?.isActive) return null;
    const usage = selectedMember.membershipPlan.serviceUsage?.find(
      u => String(u.serviceId) === String(serviceId)
    );
    if (!usage) return null;
    const remaining = usage.totalAllowed - usage.used;
    return { remaining, totalAllowed: usage.totalAllowed, used: usage.used, serviceName: usage.serviceName, isComplimentary: usage.isComplimentary };
  };

  const handleSearch = (value) => {
    setSearchValue(value);
    const keyword = value.trim().toLowerCase();
    
    if (!keyword) {
      setFilteredServices(services);
      return;
    }

    const filtered = services.filter((service) =>
      service.name.toLowerCase().includes(keyword)
    );
    setFilteredServices(filtered);
  };

  const handleAddService = (service) => {
    if (!selectedServices.some((s) => s._id === service._id)) {
      setSelectedServices((prev) => [...prev, service]);
      message.success(`${service.name} added to order`);
      
      // Reset discount when services change
      if (appliedDiscount) {
        setAppliedDiscount(null);
        setDiscountCode("");
        message.info("Discount removed. Please reapply if needed.");
      }
    }
  };

  const handleRemoveService = (serviceId) => {
    setSelectedServices((prev) => prev.filter((item) => item._id !== serviceId));
    
    // Reset discount when services change
    if (appliedDiscount) {
      setAppliedDiscount(null);
      setDiscountCode("");
      message.info("Discount removed. Please reapply if needed.");
    }
  };

  const handleTotalAmount = () => {
    return selectedServices.reduce((sum, service) => {
      const coverage = getMembershipCoverage(service._id);
      if (coverage && coverage.remaining > 0) return sum; // covered by membership — free
      return sum + service.price;
    }, 0);
  };

  const calculateDiscountAmount = () => {
    if (!appliedDiscount) return 0;
    
    const subtotal = handleTotalAmount();
    
    if (appliedDiscount.type === "Percentage") {
      return Math.round((subtotal * appliedDiscount.value) / 100);
    } else if (appliedDiscount.type === "Fixed") {
      return Math.min(appliedDiscount.value, subtotal);
    }
    
    return 0;
  };

  const getFinalAmount = () => {
    const subtotal = handleTotalAmount();
    const discount = calculateDiscountAmount();
    return Math.max(0, subtotal - discount);
  };

  const handleVerifyDiscount = async () => {
    if (!discountCode.trim()) {
      setDiscountError("Please enter a discount code");
      return;
    }

    const orderAmount = handleTotalAmount();
    
    try {
      setVerifyingDiscount(true);
      setDiscountError("");
      
  const response = await validateDiscountCode({companyId:companyId,code:discountCode,orderAmount:orderAmount})
      
      if (response?.data.success && response?.data.data) {
        setAppliedDiscount(response.data);
        toast.success(`Discount applied: ${response.data?.data?.code}`);
        
        // Check minimum order amount
        if (!response.success) {
          setDiscountError(response?.data?.data?.message||'invalid code!');
          setAppliedDiscount(response?.data?.data?.discount);
          return;
        }
      } else {
        setDiscountError(response?.data?.message || "Invalid discount code");
        setAppliedDiscount(null);
      }
    } catch (error) {
      setDiscountError("Failed to verify discount code");
      setAppliedDiscount(null);
    } finally {
      setVerifyingDiscount(false);
    }
  };

  const handleRemoveDiscount = () => {
    setAppliedDiscount(null);
    setDiscountCode("");
    setDiscountError("");
    message.info("Discount removed");
  };

  const handlePlaceOrder = () => {
    if (selectedServices.length === 0) {
      return message.warning("Please select at least one service.");
    }
    setDrawerVisible(true);
  };

  const handleSubmit = async (values) => {
    try {
      console.log(values,"values list")
      const formattedDate = moment(values?.appointmentDate).format("DD/MM/YYYY");
      const formattedTime = moment(values?.appointmentTime).format("HH:mm");
      const formattedDOB = values?.dob ? values.dob.format("YYYY-MM-DD") : null;

      setSubmitting(true);
      
      const subtotal = handleTotalAmount();
      const discountAmount = calculateDiscountAmount();
      const finalAmount = getFinalAmount();
      
      const payload = {
        ...values,
        subtotalAmount: subtotal,
        discountAmount: discountAmount,
        totalAmount: finalAmount,
        discountCode: appliedDiscount?.code || null,
        discountDetails: appliedDiscount || null,
        dob: formattedDOB,
        appointmentDate: values?.appointmentDate,
        appointmentTime: values?.appointmentTime,
        appoinmentDate: formattedDate,
        appoinmentTime: formattedTime,
        type: 'onsite',
        memberId: selectedMember?._id || null,
        serviceList: selectedServices.map((s) => {
          const coverage = getMembershipCoverage(s._id);
          const isFree = coverage && coverage.remaining > 0;
          return {
            id: s._id,
            name: s.name,
            price: isFree ? 0 : s.price,
            coveredByMembership: isFree || false,
          };
        }),
      };
    
      const res = await createOrderApi(companyId, payload);
      
      if (!res?.success) {
        toast.error(res?.message || 'Try again later!');
        return;
      }
      
      toast.success('Order created successfully!');
      setDrawerVisible(false);
      setSelectedServices([]);
      setOrderType("");
      setAppliedDiscount(null);
      setDiscountCode("");
      setDiscountError("");
      setSelectedMember(null);
      setMemberPhoneSearch("");
      setMemberOptions([]);
      form.resetFields();
      
    } catch (err) {
      console.error(err);
      message.error("Failed to place order");
    } finally {
      setSubmitting(false);
    }
  };

  const getServiceImage = (service) => {
    return service.image?.fileUrl || service.images?.[0] || null;
  };

  const ServiceCard = ({ service }) => {
    const isSelected = selectedServices.some((s) => s._id === service._id);
    const imageUrl = getServiceImage(service);
    const coverage = getMembershipCoverage(service._id);
    const isCovered = coverage && coverage.remaining > 0;

    return (
      <Card
        hoverable
        style={{
          borderRadius: '16px',
          overflow: 'hidden',
          border: isSelected ? '2px solid #1890ff' : '1px solid #f0f0f0',
          boxShadow: isSelected 
            ? '0 8px 32px rgba(24,144,255,0.3)' 
            : '0 4px 12px rgba(0,0,0,0.1)',
          transition: 'all 0.3s ease',
          position: 'relative',
        }}
        bodyStyle={{ padding: '16px' }}
        cover={
          <div style={{ 
            position: 'relative', 
            height: '180px',
            background: imageUrl 
              ? 'transparent' 
              : 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
            overflow: 'hidden'
          }}>
            {imageUrl ? (
              <img
                src={imageUrl}
                alt={service.name}
                style={{
                  width: '100%',
                  height: '100%',
                  objectFit: 'cover',
                }}
              />
            ) : (
              <div style={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                height: '100%',
                color: 'white',
                textAlign: 'center'
              }}>
                <div style={{
                  width: '60px',
                  height: '60px',
                  borderRadius: '50%',
                  background: 'rgba(255,255,255,0.2)',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  marginBottom: '12px'
                }}>
                  <span style={{ fontSize: '24px', fontWeight: 'bold' }}>
                    {service.name.charAt(0).toUpperCase()}
                  </span>
                </div>
                <Text style={{ color: 'white', fontSize: '12px', opacity: 0.8 }}>
                  Service Image
                </Text>
              </div>
            )}

            <div style={{
              position: 'absolute',
              top: '12px',
              right: '12px',
              background: isCovered ? 'rgba(82,196,26,0.9)' : 'rgba(0,0,0,0.8)',
              color: 'white',
              padding: '6px 12px',
              borderRadius: '16px',
              fontSize: '14px',
              fontWeight: 'bold',
              backdropFilter: 'blur(4px)'
            }}>
              {isCovered ? <><CrownOutlined style={{ marginRight: 4 }} />Free</> : `₹${service.price}`}
            </div>

            {isSelected && (
              <div style={{
                position: 'absolute',
                top: '12px',
                left: '12px',
                background: '#52c41a',
                color: 'white',
                padding: '4px 8px',
                borderRadius: '12px',
                fontSize: '12px',
                fontWeight: 'bold'
              }}>
                <CheckCircleOutlined style={{ marginRight: '4px' }} />
                Added
              </div>
            )}
          </div>
        }
        actions={[
          isSelected ? (
            <Button
              danger
              icon={<MinusOutlined />}
              onClick={() => handleRemoveService(service._id)}
              style={{ borderRadius: '8px' }}
            >
              Remove
            </Button>
          ) : (
            <Button 
              type="primary" 
              icon={<PlusOutlined />}
              onClick={() => handleAddService(service)}
              style={{ borderRadius: '8px' }}
            >
              Add Service
            </Button>
          ),
        ]}
      >
        <Meta 
          title={
            <Text strong style={{ fontSize: '16px', color: '#1a1a1a' }}>
              {service.name}
            </Text>
          }
          description={
            <div style={{ marginTop: '8px' }}>
              <Text type="secondary" style={{ fontSize: '14px' }}>
                Professional service
              </Text>
            </div>
          }
        />
      </Card>
    );
  };

  return (
    <div style={{ 
      minHeight: '100vh',
      background: 'linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%)',
      padding: '24px',
      paddingBottom: selectedServices.length > 0 ? '120px' : '24px'
    }}>
      <div style={{ maxWidth: '1400px', margin: '0 auto' }}>
        {/* Header */}
        <div style={{
          background: 'white',
          borderRadius: '20px',
          padding: '32px',
          marginBottom: '24px',
          boxShadow: '0 8px 32px rgba(0,0,0,0.1)'
        }}>
          <Row align="middle" justify="space-between">
            <Col>
              <Title level={2} style={{ 
                margin: 0,
                marginBottom: '8px',
                background: 'linear-gradient(45deg, #1890ff, #722ed1)',
                WebkitBackgroundClip: 'text',
                WebkitTextFillColor: 'transparent',
                fontSize: '32px'
              }}>
                Create New Order
              </Title>
              <Text type="secondary" style={{ fontSize: '16px' }}>
                Select services and create an order for your client
              </Text>
            </Col>
            <Col>
              <Badge count={selectedServices.length} style={{ backgroundColor: '#52c41a' }}>
                <Avatar 
                  size={48} 
                  icon={<ShoppingCartOutlined />} 
                  style={{ backgroundColor: '#1890ff' }}
                />
              </Badge>
            </Col>
          </Row>
        </div>

        {/* Search */}
        <div style={{
          background: 'white',
          borderRadius: '20px',
          padding: '24px',
          marginBottom: '24px',
          boxShadow: '0 8px 32px rgba(0,0,0,0.1)'
        }}>
          <Row align="middle" gutter={[16, 16]}>
            <Col xs={24} md={16}>
              <Search
                placeholder="Search services..."
                size="large"
                prefix={<SearchOutlined />}
                value={searchValue}
                onChange={(e) => handleSearch(e.target.value)}
                style={{ borderRadius: '12px' }}
                allowClear
              />
            </Col>
            <Col xs={24} md={8} style={{ textAlign: 'right' }}>
              <div style={{
                background: 'linear-gradient(45deg, #1890ff, #722ed1)',
                color: 'white',
                padding: '8px 16px',
                borderRadius: '20px',
                fontSize: '14px',
                fontWeight: 'bold',
                display: 'inline-block'
              }}>
                {filteredServices.length} Services Available
              </div>
            </Col>
          </Row>
        </div>

        {/* Services Grid */}
        <div style={{
          background: 'white',
          borderRadius: '20px',
          padding: '24px',
          boxShadow: '0 8px 32px rgba(0,0,0,0.1)'
        }}>
          {loading ? (
            <div style={{ textAlign: 'center', padding: '60px 0' }}>
              <Spin size="large" />
              <div style={{ marginTop: '16px' }}>
                <Text type="secondary">Loading services...</Text>
              </div>
            </div>
          ) : filteredServices.length === 0 ? (
            <div style={{ textAlign: 'center', padding: '60px 0' }}>
              <Empty 
                description={
                  searchValue 
                    ? `No services found for "${searchValue}"` 
                    : "No services available"
                }
                image={Empty.PRESENTED_IMAGE_SIMPLE}
              />
            </div>
          ) : (
            <Row gutter={[24, 24]}>
              {filteredServices.map((service) => (
                <Col xs={24} sm={12} md={8} lg={6} key={service._id}>
                  <ServiceCard service={service} />
                </Col>
              ))}
            </Row>
          )}
        </div>
      </div>

      {/* Selected Services Footer */}
      {selectedServices.length > 0 && (
        <div style={{
          position: "fixed",
          bottom: 0,
          left: 0,
          right: 0,
          background: "white",
          padding: "20px 24px",
          boxShadow: "0 -4px 20px rgba(0, 0, 0, 0.1)",
          borderTop: "1px solid #f0f0f0",
          zIndex: 1000,
        }}>
          <div style={{ maxWidth: '1400px', margin: '0 auto' }}>
            <div style={{
              display: "flex",
              overflowX: "auto",
              gap: "12px",
              marginBottom: "16px",
              paddingBottom: "8px",
            }}>
              {selectedServices.map((service) => {
                const coverage = getMembershipCoverage(service._id);
                const isFree = coverage && coverage.remaining > 0;
                return (
                <div
                  key={service._id}
                  style={{
                    background: isFree
                      ? "linear-gradient(135deg, #f6ffed 0%, #d9f7be 100%)"
                      : "linear-gradient(135deg, #f0f9ff 0%, #e0e7ff 100%)",
                    border: isFree ? "1px solid #95de64" : "1px solid #bfdbfe",
                    padding: "12px 16px",
                    borderRadius: "12px",
                    minWidth: "180px",
                    position: "relative",
                    whiteSpace: "nowrap",
                  }}
                >
                  <div style={{ fontWeight: 600, fontSize: "14px", color: isFree ? "#237804" : "#1e40af" }}>
                    {service.name}
                  </div>
                  <div style={{ fontSize: "12px", color: "#64748b", marginTop: "4px" }}>
                    {isFree ? <Tag color="green" style={{ fontSize: 10, padding: '0 4px' }} icon={<CrownOutlined />}>Free (Plan)</Tag> : `₹${service.price}`}
                  </div>
                  <Button
                    type="text"
                    size="small"
                    icon={<CloseOutlined />}
                    onClick={() => handleRemoveService(service._id)}
                    style={{
                      position: "absolute",
                      top: "4px",
                      right: "4px",
                      width: "20px",
                      height: "20px",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      color: "#64748b",
                      border: 'none',
                      background: 'rgba(255, 255, 255, 0.9)',
                      borderRadius: '50%',
                      fontSize: '10px',
                      boxShadow: '0 1px 4px rgba(0,0,0,0.1)'
                    }}
                  />
                </div>
                );
              })}
            </div>

            <Row align="middle" justify="space-between">
              <Col>
                <Space align="center">
                  <DollarOutlined style={{ color: '#52c41a', fontSize: '18px' }} />
                  <Text strong style={{ fontSize: '18px', color: '#52c41a' }}>
                    Total: ₹{appliedDiscount ? getFinalAmount() : handleTotalAmount()}
                  </Text>
                  {appliedDiscount && (
                    <Text delete type="secondary" style={{ fontSize: '14px' }}>
                      ₹{handleTotalAmount()}
                    </Text>
                  )}
                  <Text type="secondary">
                    ({selectedServices.length} service{selectedServices.length !== 1 ? 's' : ''})
                  </Text>
                </Space>
              </Col>
              <Col>
                <Button
                  type="primary"
                  size="large"
                  icon={<ShoppingCartOutlined />}
                  onClick={handlePlaceOrder}
                  style={{
                    borderRadius: '12px',
                    background: 'linear-gradient(45deg, #1890ff, #722ed1)',
                    border: 'none',
                    boxShadow: '0 4px 12px rgba(24,144,255,0.4)',
                    minWidth: '140px'
                  }}
                >
                  Place Order
                </Button>
              </Col>
            </Row>
          </div>
        </div>
      )}

      {/* Order Drawer */}
      <Drawer
        title={
          <div style={{ fontSize: '20px', fontWeight: 'bold' }}>
            <ShoppingCartOutlined style={{ marginRight: '8px', color: '#1890ff' }} />
            Place Order
          </div>
        }
        width={500}
        onClose={() => {
          setDrawerVisible(false);
          setOrderType("");
        }}
        open={drawerVisible}
        destroyOnClose
        style={{ borderRadius: '16px' }}
      >
        <div style={{ marginBottom: '24px' }}>
          <Title level={4} style={{ color: '#1890ff', marginBottom: '16px' }}>
            Order Summary
          </Title>
          <div style={{
            background: '#f8fafc',
            padding: '16px',
            borderRadius: '12px',
            marginBottom: '24px'
          }}>
            {selectedServices.map((service, index) => {
              const cov = getMembershipCoverage(service._id);
              const free = cov && cov.remaining > 0;
              return (
              <div key={service._id}>
                <Row justify="space-between" align="middle">
                  <Col>
                    <Space size={4}>
                      <Text strong>{service.name}</Text>
                      {free && <Tag color="green" style={{ fontSize: 10, padding: '0 4px' }} icon={<CrownOutlined />}>Plan</Tag>}
                    </Space>
                  </Col>
                  <Col>
                    {free
                      ? <><Text delete type="secondary" style={{ fontSize: 12 }}>₹{service.price}</Text> <Text strong style={{ color: '#52c41a' }}>₹0</Text></>
                      : <Text strong style={{ color: '#52c41a' }}>₹{service.price}</Text>
                    }
                  </Col>
                </Row>
                {index < selectedServices.length - 1 && <Divider style={{ margin: '8px 0' }} />}
              </div>
              );
            })}
            <Divider />
            
            {/* Discount Code Section */}
            <div style={{ marginBottom: '16px' }}>
              <Text strong style={{ color: '#722ed1', marginBottom: '8px', display: 'block' }}>
                <GiftOutlined style={{ marginRight: '4px' }} />
                Discount Code
              </Text>
              
              {!appliedDiscount ? (
                <div>
                  <Space.Compact style={{ width: '100%', marginBottom: '8px' }}>
                    <Input
                      placeholder="Enter discount code"
                      value={discountCode}
                      onChange={(e) => {
                        setDiscountCode(e.target.value.toUpperCase());
                        setDiscountError("");
                      }}
                      style={{ borderRadius: '8px 0 0 8px' }}
                      prefix={<TagOutlined />}
                    />
                    <Button
                      type="primary"
                      loading={verifyingDiscount}
                      onClick={handleVerifyDiscount}
                      style={{
                        borderRadius: '0 8px 8px 0',
                        background: '#722ed1',
                        borderColor: '#722ed1'
                      }}
                    >
                      Apply
                    </Button>
                  </Space.Compact>
                  
                  {discountError && (
                    <Text type="danger" style={{ fontSize: '12px' }}>
                      {discountError}
                    </Text>
                  )}
                </div>
              ) : (
                <div style={{
                  background: '#f6ffed',
                  border: '1px solid #b7eb8f',
                  borderRadius: '8px',
                  padding: '12px'
                }}>
                  <Row justify="space-between" align="middle">
                    <Col>
                      <Space>
                        <Tag color="green" icon={<CheckCircleOutlined />}>
                          {appliedDiscount.code}
                        </Tag>
                        <Text style={{ fontSize: '12px', color: '#52c41a' }}>
                          {appliedDiscount.type === "Percentage" 
                            ? `${appliedDiscount.value}% OFF`
                            : `₹${appliedDiscount.value} OFF`
                          }
                        </Text>
                      </Space>
                    </Col>
                    <Col>
                      <Button
                        type="text"
                        size="small"
                        icon={<CloseOutlined />}
                        onClick={handleRemoveDiscount}
                        style={{ color: '#ff4d4f' }}
                      >
                        Remove
                      </Button>
                    </Col>
                  </Row>
                </div>
              )}
            </div>

            {/* Order Totals */}
            <Row justify="space-between" align="middle" style={{ marginBottom: '8px' }}>
              <Col>
                <Text>Subtotal</Text>
              </Col>
              <Col>
                <Text>₹{handleTotalAmount()}</Text>
              </Col>
            </Row>

            {appliedDiscount && (
              <Row justify="space-between" align="middle" style={{ marginBottom: '8px' }}>
                <Col>
                  <Text style={{ color: '#52c41a' }}>
                    <PercentageOutlined style={{ marginRight: '4px' }} />
                    Discount ({appliedDiscount.code})
                  </Text>
                </Col>
                <Col>
                  <Text style={{ color: '#52c41a' }}>
                    -₹{calculateDiscountAmount()}
                  </Text>
                </Col>
              </Row>
            )}

            <Divider style={{ margin: '12px 0' }} />
            <Row justify="space-between" align="middle">
              <Col>
                <Text strong style={{ fontSize: '16px' }}>Total Amount</Text>
              </Col>
              <Col>
                <Text strong style={{ fontSize: '18px', color: '#1890ff' }}>
                  ₹{getFinalAmount()}
                </Text>
              </Col>
            </Row>
          </div>
        </div>

        {/* Member Search */}
        <div style={{ marginBottom: 24 }}>
          <Text strong style={{ display: 'block', marginBottom: 8 }}>
            <SearchOutlined style={{ marginRight: 4, color: '#1890ff' }} />
            Search Member by Mobile
          </Text>
          <AutoComplete
            value={memberPhoneSearch}
            options={memberOptions}
            onSearch={searchMembersByPhone}
            onSelect={handleMemberSelect}
            placeholder="Type mobile number to search member..."
            style={{ width: '100%' }}
            notFoundContent={memberSearchLoading ? <Spin size="small" /> : memberPhoneSearch.length >= 3 ? 'No member found' : null}
          >
            <Input
              size="large"
              prefix={<PhoneOutlined style={{ color: '#1890ff' }} />}
              suffix={
                selectedMember ? (
                  <Button type="text" size="small" icon={<CloseOutlined />} onClick={clearMember} />
                ) : memberSearchLoading ? <Spin size="small" /> : null
              }
              style={{ borderRadius: 8 }}
            />
          </AutoComplete>

          {/* Selected Member Info Panel */}
          {selectedMember && (
            <div style={{ marginTop: 12, background: '#f0f9ff', border: '1px solid #91d5ff', borderRadius: 10, padding: 14 }}>
              <Space align="start" style={{ width: '100%', justifyContent: 'space-between' }}>
                <Space align="start">
                  <Avatar icon={<UserOutlined />} style={{ backgroundColor: '#1890ff' }} />
                  <div>
                    <div style={{ fontWeight: 600 }}>{selectedMember.name}</div>
                    <div style={{ fontSize: 12, color: '#888' }}>{selectedMember.phone} {selectedMember.email ? `· ${selectedMember.email}` : ''}</div>
                    <div style={{ marginTop: 4 }}>
                      {selectedMember.membershipPlan?.isActive ? (
                        <Tag color="gold" icon={<CrownOutlined />}>{selectedMember.membershipPlan.planName}</Tag>
                      ) : (
                        <Tag color="default">No Active Plan</Tag>
                      )}
                    </div>
                  </div>
                </Space>
              </Space>

              {/* Membership Services */}
              {selectedMember.membershipPlan?.isActive && selectedMember.membershipPlan?.serviceUsage?.length > 0 && (
                <div style={{ marginTop: 12 }}>
                  <Divider style={{ margin: '8px 0' }} />
                  <Text strong style={{ fontSize: 12, color: '#722ed1' }}>
                    <CrownOutlined style={{ marginRight: 4 }} />
                    Membership Services
                  </Text>
                  <div style={{ marginTop: 8 }}>
                    {selectedMember.membershipPlan.serviceUsage.map((u, i) => {
                      const remaining = u.totalAllowed - u.used;
                      const pct = Math.round((u.used / u.totalAllowed) * 100);
                      return (
                        <div key={i} style={{ marginBottom: 8 }}>
                          <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: 12 }}>
                            <Space size={4}>
                              <Text style={{ fontSize: 12 }}>{u.serviceName}</Text>
                              {u.isComplimentary && <Tag color="green" style={{ fontSize: 10, padding: '0 4px' }} icon={<GiftOutlined />}>Free</Tag>}
                            </Space>
                            <Text style={{ fontSize: 12 }} type={remaining > 0 ? 'success' : 'danger'}>
                              {remaining > 0 ? `${remaining} left` : 'Exhausted'}
                            </Text>
                          </div>
                          <Progress
                            percent={pct}
                            size="small"
                            showInfo={false}
                            strokeColor={remaining > 0 ? '#52c41a' : '#ff4d4f'}
                            style={{ marginTop: 2 }}
                          />
                        </div>
                      );
                    })}
                  </div>
                  <div style={{ fontSize: 11, color: '#888', marginTop: 4 }}>
                    Services with remaining uses will be <strong>free of charge</strong> in this order.
                  </div>
                </div>
              )}
            </div>
          )}
        </div>

        <Form layout="vertical" form={form} onFinish={handleSubmit}>
          <Title level={4} style={{ color: '#1890ff', marginBottom: '16px' }}>
            Client Information
          </Title>

          <Form.Item
            name="clientName"
            label={<Text strong><UserOutlined style={{ marginRight: '4px' }} />Client Name</Text>}
            rules={[{ required: true, message: "Enter client name" }]}
          >
            <Input 
              placeholder="Enter client full name"
              size="large"
              style={{ borderRadius: '8px' }}
            />
          </Form.Item>

          <Form.Item
            name="number"
            label={<Text strong><PhoneOutlined style={{ marginRight: '4px' }} />Mobile Number</Text>}
            rules={[
              { required: true, message: "Enter mobile number" },
              { len: 10, message: "Must be 10 digits" },
            ]}
          >
            <Input 
              placeholder="Enter 10-digit mobile number"
              size="large"
              style={{ borderRadius: '8px' }}
            />
          </Form.Item>

          <Form.Item
            name="dob"
            label={
              <Text strong>
                <CalendarOutlined style={{ marginRight: '4px' }} />
                Date of Birth
              </Text>
            }
            rules={[
              { required: true, message: 'Please select your date of birth' },
              {
                validator: (_, value) => {
                  if (!value) return Promise.resolve();
                  
                  const today = moment();
                  const birthDate = moment(value);
                  const age = today.diff(birthDate, 'years');
                  
                  return Promise.resolve();
                }
              }
            ]}
          >
            <DatePicker
              placeholder="Select date of birth"
              size="large"
              style={{ width: '100%', borderRadius: '8px' }}
              format="DD/MM/YYYY"
              disabledDate={(current) => {
                const today = moment().endOf('day');
                const minDate = moment().subtract(120, 'years');
                return current && (current > today || current < minDate);
              }}
              showToday={false}
              picker="date"
            />
          </Form.Item>

          <Form.Item 
            name="email" 
            label={<Text strong><MailOutlined style={{ marginRight: '4px' }} />Email (Optional)</Text>}
          >
            <Input 
              type="email" 
              placeholder="Enter email address"
              size="large"
              style={{ borderRadius: '8px' }}
            />
          </Form.Item>

          <Divider />

          <Title level={4} style={{ color: '#1890ff', marginBottom: '16px' }}>
            Service Details
          </Title>

          <Form.Item
            name={["staff", "userId"]}
            label={<Text strong><TeamOutlined style={{ marginRight: '4px' }} />Select Staff</Text>}
            rules={[{ required: true, message: "Please select staff" }]}
          >
            <Select
              showSearch
              placeholder="Search and select staff member"
              size="large"
              filterOption={false}
              onSearch={fetchStaff}
              loading={fetchingStaff}
              notFoundContent={fetchingStaff ? <Spin size="small" /> : "No staff found"}
              onChange={(value, option) => {
                // Extract staff name from option label
                const staffName = staffList.find(staff => staff._id === value)?.name || '';
                form.setFieldValue(["staff", "userName"], staffName);
              }}
              style={{ borderRadius: '8px' }}
              dropdownStyle={{ borderRadius: '8px' }}
            >
              {staffList.map((user) => (
                <Option key={user._id} value={user._id}>
                  <Space align="center">
                    <Avatar 
                      size="small" 
                      icon={<UserOutlined />} 
                      style={{ 
                        backgroundColor: '#1890ff',
                        flexShrink: 0
                      }} 
                    />
                    <div style={{ overflow: 'hidden' }}>
                      <div style={{ 
                        fontWeight: '500',
                        color: '#262626',
                        whiteSpace: 'nowrap',
                        overflow: 'hidden',
                        textOverflow: 'ellipsis'
                      }}>
                        {user.name}
                      </div>
                    </div>
                  </Space>
                </Option>
              ))}
            </Select>
          </Form.Item>

          <Form.Item
            name={["staff", "userName"]}
            style={{ display: 'none' }}
          >
            <Input />
          </Form.Item>

          {/* Appointment Date & Time Fields - Only show for scheduled orders */}
          {orderType === "scheduled" && (
            <>
              <Form.Item
                name="appointmentDate"
                label={<Text strong><CalendarOutlined style={{ marginRight: '4px' }} />Appointment Date</Text>}
                rules={[{ required: true, message: "Please select appointment date" }]}
              >
                <DatePicker
                  size="large"
                  style={{ width: '100%', borderRadius: '8px' }}
                  placeholder="Select appointment date"
                  disabledDate={(current) => current && current.isBefore(new Date(), 'day')}
                  format="DD/MM/YYYY"
                />
              </Form.Item>

              <Form.Item
                name="appointmentTime"
                label={<Text strong><ClockCircleOutlined style={{ marginRight: '4px' }} />Appointment Time</Text>}
                rules={[{ required: true, message: "Please select appointment time" }]}
              >
                <TimePicker
                  size="large"
                  style={{ width: '100%', borderRadius: '8px' }}
                  placeholder="Select appointment time"
                  format="HH:mm"
                  minuteStep={15}
                  showNow={false}
                />
              </Form.Item>

              <div style={{
                background: '#e6f7ff',
                border: '1px solid #91d5ff',
                borderRadius: '8px',
                padding: '12px',
                marginBottom: '16px'
              }}>
                <Space>
                  <ClockCircleOutlined style={{ color: '#1890ff' }} />
                  <Text style={{ fontSize: '12px', color: '#1890ff' }}>
                    <strong>Note:</strong> Appointment will be scheduled for the selected date and time. 
                    Please ensure the selected slot is available.
                  </Text>
                </Space>
              </div>
            </>
          )}

          <Form.Item
            name="paymentMode"
            label={<Text strong><CreditCardOutlined style={{ marginRight: '4px' }} />Payment Mode</Text>}
            rules={[{ required: true, message: "Please select payment mode" }]}
          >
            <Select 
              placeholder="Select payment method"
              size="large"
              style={{ borderRadius: '8px' }}
            >
              <Option value="cash">
                <Space>
                  <DollarOutlined style={{ color: '#52c41a' }} />
                  <span>Cash Payment</span>
                </Space>
              </Option>
              <Option value="online">
                <Space>
                  <CreditCardOutlined style={{ color: '#1890ff' }} />
                  <span>Online Payment</span>
                </Space>
              </Option>
            </Select>
          </Form.Item>

          <Form.Item style={{ marginTop: '32px' }}>
            <Button
              type="primary"
              htmlType="submit"
              size="large"
              loading={submitting}
              block
              style={{
                borderRadius: '12px',
                height: '48px',
                background: 'linear-gradient(45deg, #52c41a, #389e0d)',
                border: 'none',
                fontSize: '16px',
                fontWeight: 'bold'
              }}
            >
              {submitting ? 'Creating Order...' : 'Confirm & Place Order'}
            </Button>
          </Form.Item>
        </Form>
      </Drawer>
    </div>
  );
}